import { render, staticRenderFns } from "./TempleOrderList.vue?vue&type=template&id=045ab663&scoped=true"
import script from "./TempleOrderList.vue?vue&type=script&lang=js"
export * from "./TempleOrderList.vue?vue&type=script&lang=js"
import style0 from "./TempleOrderList.vue?vue&type=style&index=0&id=045ab663&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ab663",
  null
  
)

export default component.exports